


import { Component, Vue, Prop, Emit } from 'vue-property-decorator';

@Component({})
export default class InfoDialog extends Vue {
  @Prop({ default: '' }) private headline!: string;
  @Prop({ default: '' }) private message!: string;
  @Prop({ default: '' }) private declineCta!: string;
  @Prop({ default: '' }) private acceptCta!: string;
  @Prop() private resolve!: () => void;
  @Prop() private reject!: () => void;

  private acceptClicked() {
    this.resolve();
    this.closeModal();
  }

  private declineClicked() {
    this.reject();
    this.closeModal();
  }

  @Emit()
  private closeModal() {
    return;
  }
}
